import { message } from 'antd';
import { messages } from 'constants/index';

export const requestFeedback = (status, successMessage) => {
  status < 400 ? message.success(successMessage) : message.error(messages.onError);
};

export const isNumeric = value => {
  return /^-?\d+$/.test(value);
};
